import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import ProductCountries from "../../Components/Header/ProductCountries";
import formatPrice from "../../Components/formatPrice";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import GradeIcon from "@mui/icons-material/Grade";
import Skeleton from "@material-ui/lab/Skeleton";
import FlashOnIcon from "@mui/icons-material/FlashOn";
var moment = require("moment");

function ApisSearchResults({ getProducts, userData, isFetching }) {
  const { languageCode } = useSelector((state) => state.auth);
  const { t } = useTranslation();
  const location = useLocation();
  const isMobcreen = useMediaQuery({ query: "(min-width: 0px) and (max-width: 768px)" });
  const searchCountry = new URLSearchParams(location.search).get("country") || null;
  function getDeliverydays(delivery) {
    const deliveryDaya = Number(delivery) + Number(userData?.contant?.delivery_days || 0);
    function getTimeline() {
      if (Number(deliveryDaya) === 1) {
        return (
          <>
            {t("delivery_by")} <strong>Tomorrow</strong> {moment().add(Number(deliveryDaya), "days").format("Do")}
          </>
        );
      } else {
        return (
          <>
            {t("delivery_by")} {moment().add(Number(deliveryDaya), "days").format("Do MMM")}
          </>
        );
      }
    }
    if (Number(deliveryDaya) > 0) {
      // return getTimeline()
      return `${t("delivery_by")} ${moment().add(14, "days").format("Do MMM")}`;
    } else {
      return `${t("delivery_by")} ${moment().add(14, "days").format("Do MMM")}`;
    }
  }

  function productTitle(title) {
    return title
      ?.replace(/[^A-Za-z0-9]/g, " ")
      ?.replace(/[^\w\s]/gi, " ")
      ?.replace(/ /g, "-");
  }

  const handleError = (e) => {
    console.error("Error loading image:", e.target.src);
    e.target.src = "https://cdn.ebtida.com/1705315901965-Image-not-found.jpg";
  };

  const beforeLoadHandler = () => (
    <img className="img-item" src="https://cdn.ebtida.com/1705315901965-Image-not-found.jpg" />
  );

  function ratingFucn(rating) {
    if (rating === 0) {
      return false;
    } else if (rating === "0") {
      return false;
    } else if (!rating) {
      return false;
    } else {
      return true;
    }
  }

  const storeIds = [1, 3, 18, 19, 20, 21, 22, 23, 25, 11, 12, 26];
  function functionIdLink(id, pid, store_id) {
    if (storeIds?.includes(Number(store_id))) {
      return pid;
    } else {
      return id;
    }
  }

  function checkIfAnyNumber(badge) {
    return /\d|×/.test(badge);
  }

  function removeDuplicates(inputString) {
    const lowerInput = inputString?.toLowerCase();
    if (lowerInput?.includes("prime") || lowerInput?.includes("amazon")) {
      return false;
    }
    const wordsArray = inputString?.split(/\s+/);
    const uniqueWords = [...new Set(wordsArray)];
    const result = uniqueWords?.join(" ");
    return result;
  }

  function loadCountrySkeleton(fetch, country, itemCountry) {
    if (!country) {
      return false;
    }
    if (fetch && country != itemCountry) {
      return true;
    }
    return false;
  }

  return (
    <>
      {getProducts?.map((item, i) => {
        const prices = item?.prices;
        const inStock = item?.in_stock;
        const brand = item?.brand;
        const dealbBadge = item?.deal_badge;
        return (
          <div className="col-md-3 cardItem" style={{ padding: "5px" }} key={i}>
            <Link
              style={{ position: "relative" }}
              className="cardItem-item"
              to={`/${languageCode}/product/${item?.store_id}/${functionIdLink(item?.id, item?.pid, item?.store_id)}/${productTitle(item?.title)}?country=${item?.country}`}
            >
              {checkIfAnyNumber(dealbBadge)
                ? ""
                : removeDuplicates(dealbBadge) && <div className="deal--badge--">{removeDuplicates(dealbBadge)}</div>}
              <div className="img-card imgCard">
                <LazyLoadImage
                  delayTime={100}
                  key={i}
                  alt={item?.title}
                  effect="blur"
                  className="img-item"
                  src={item?.image}
                  onError={handleError}
                  beforeLoad={beforeLoadHandler}
                />

                <div className={`delivery-days`}>
                  <span style={{ padding: 0 }} className={isMobcreen ? `badge badge-secondary` : ``}>
                    {getDeliverydays(item.estimated_delivery)}
                  </span>
                </div>
                {item?.prices?.deal_value && (
                  <span
                    className="badge badge-danger"
                    style={{ position: "absolute", left: "5px", top: "5px", zIndex: 111, width: "auto" }}
                  >
                    <FlashOnIcon style={{ fontSize: "1rem" }} />
                  </span>
                )}
              </div>
              <div className="card-content">
                <div className="title-card" style={{ maxHeight: "45px", minHeight: "45px" }}>
                  <h4>{item?.title?.replace(/[^\w\s.,'/:]/gi, " ")}</h4>
                </div>

                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  {brand && (
                    <div className="brand" style={{ width: "100%" }}>
                      {brand}
                    </div>
                  )}
                  {ratingFucn(item?.rating) && (
                    <div
                      className="rating"
                      style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", width: "100%" }}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          color: "#575959",
                          margin: "0px 3px",
                          fontSize: "14px",
                        }}
                      >
                        {item?.rating}
                      </span>
                      <GradeIcon style={{ color: "#151517", fontSize: "1rem", marginTop: "-1.5px" }} />
                    </div>
                  )}
                </div>
                <div className="content-item" style={{ padding: "5px 0px 5px 0px" }}>
                  <div className="item-price-card" style={{ alignItems: "flex-end" }}>
                    <>
                      {Number(prices?.bdp) === 0 ? (
                        <span className="badge badge-secondary">Check Price</span>
                      ) : (
                        <>
                          {inStock ? (
                            <>
                              <span className="item-deal-price">
                                <div style={{ lineHeight: 1.2 }}>
                                  {formatPrice(prices?.value, prices?.currency, 0)}&nbsp;
                                </div>
                              </span>
                              {prices?.deal_value && (
                                <span
                                  className="item-price"
                                  style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}
                                >
                                  <small style={{ textDecoration: "line-through", color: "#828282" }}>
                                    {formatPrice(prices?.price, prices?.currency, 0)}
                                  </small>
                                  {/* {prices?.discount ?
                                    <span className='badge badge-danger'>
                                      {`-${prices?.discount}%`}
                                    </span> : ``
                                  } */}
                                </span>
                              )}
                            </>
                          ) : (
                            ""
                          )}
                        </>
                      )}
                    </>
                  </div>
                </div>
                <div
                  style={{
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                  }}
                >
                  {loadCountrySkeleton(isFetching, searchCountry, item?.country) ? (
                    <Skeleton style={{ height: "22px", width: "30%" }} />
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: "12px",
                        lineHeight: 0,
                        color: "#575959",
                      }}
                    >
                      {t("From")}&nbsp;
                      <img
                        style={{ width: "20px", objectFit: "contain" }}
                        loading="lazy"
                        src={`https://flagcdn.com/w20/${item?.country?.toLowerCase()}.png`}
                        srcSet={`https://flagcdn.com/w40/${item?.country?.toLowerCase()}.png 2x`}
                        alt=""
                      />
                      &nbsp;
                      <div style={{ fontSize: "12px", lineHeight: 0, color: "#575959" }}>
                        {ProductCountries(item?.country)}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Link>
          </div>
        );
      })}
    </>
  );
}

export default ApisSearchResults;
